import { observable, action, runInAction } from 'mobx';
import util from 'preact-util';

class IdexxAdminStore {
    @observable overview = null;
    @observable customerDetail = null;
    @observable expandedCustomerId = null;
    @observable loading = false;
    @observable error = null;

    constructor() {
        this.name = 'idexxAdmin';
    }

    @action
    async loadOverview({ startDate, endDate } = {}) {
        this.loading = true;
        this.error = null;
        try {
            const qs = {};
            if (startDate) qs.startDate = new Date(startDate).toISOString();
            if (endDate) qs.endDate = new Date(endDate).toISOString();
            const response = await util.fetchApi('/api/integrations/idexx/admin/overview', { method: 'GET' }, qs);
            runInAction(() => {
                if (response.status === 200) {
                    this.overview = response.data;
                } else {
                    this.error = response.message || 'Failed to load overview';
                }
                this.loading = false;
            });
            return response;
        } catch (e) {
            runInAction(() => {
                this.error = e.message;
                this.loading = false;
            });
            return null;
        }
    }

    @action
    async loadCustomerDetail(customerId, { startDate, endDate } = {}) {
        this.loading = true;
        this.error = null;
        try {
            const qs = {};
            if (startDate) qs.startDate = new Date(startDate).toISOString();
            if (endDate) qs.endDate = new Date(endDate).toISOString();
            const response = await util.fetchApi(
                `/api/integrations/idexx/admin/customer/${customerId}`,
                { method: 'GET' },
                qs,
            );
            runInAction(() => {
                if (response.status === 200) {
                    this.customerDetail = response.data;
                    this.expandedCustomerId = customerId;
                } else {
                    this.error = response.message || 'Failed to load detail';
                }
                this.loading = false;
            });
            return response;
        } catch (e) {
            runInAction(() => {
                this.error = e.message;
                this.loading = false;
            });
            return null;
        }
    }

    @action
    collapseCustomer() {
        this.customerDetail = null;
        this.expandedCustomerId = null;
    }

    async getReportMarkdown(customerId, { startDate, endDate } = {}) {
        const apiServer = util.getApiServer();
        const qs = new URLSearchParams({ format: 'md' });
        if (startDate) qs.set('startDate', new Date(startDate).toISOString());
        if (endDate) qs.set('endDate', new Date(endDate).toISOString());
        const jwtToken = util.getJwtToken();
        const url = `${apiServer}/api/integrations/idexx/admin/customer/${customerId}/report?${qs.toString()}`;
        const resp = await fetch(url, {
            headers: { Authorization: `Bearer ${jwtToken}` },
        });
        if (!resp.ok) {
            throw new Error(`Report fetch failed: ${resp.status}`);
        }
        return resp.text();
    }
}

const idexxAdminStore = new IdexxAdminStore();
export default idexxAdminStore;
